(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SECTION = 'cart-drawer';

    function drawer() {
      return document.querySelector('[data-cart-drawer]');
    }

    function open() {
      var el = drawer();
      if (!el) return;
      el.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      var el = drawer();
      if (!el) return;
      el.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    // Re-rendering through the section rendering api keeps the markup in the
    // liquid above rather than building a second copy of it in javascript,
    // so the two cannot drift apart.
    function refresh() {
      // ?sections= is used rather than ?section_id=. The latter renders the
      // section file on its own with its defaults, which quietly dropped the
      // settings and the assurance blocks configured on the section group, so
      // the badges disappeared the moment the cart was touched.
      // cache: no-store matters here. Without it the browser happily served
      // the section html from before the item was added, so the drawer opened
      // showing an empty cart that the cart itself disagreed with.
      // ?sections= returns an empty string for anything living in a section
      // group, so section_id is what actually works here.
      return fetch('/cart?section_id=' + SECTION + '&t=' + Date.now(),
        { headers: { Accept: 'text/html' }, cache: 'no-store' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var fresh = parsed.querySelector('[data-cart-drawer-cart]');
          var current = document.querySelector('[data-cart-drawer-cart]');
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        });
    }

    function setQuantity(line, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(refresh).then(updateCount);
    }

    function updateCount() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-header-cart-count]').forEach(function (node) {
            node.setAttribute('data-header-cart-count', cart.item_count ? cart.item_count : '');
            node.classList.toggle('visible', cart.item_count > 0);
          });
        });
    }

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-cart-drawer-close]')) {
        close();
        return;
      }

      var qty = event.target.closest('[data-cart-qty]');
      if (qty) {
        event.preventDefault();
        setQuantity(parseInt(qty.getAttribute('data-cart-qty'), 10),
                    parseInt(qty.getAttribute('data-to'), 10));
        return;
      }

      // the cart icon in the header opens the drawer rather than leaving the page
      var cartLink = event.target.closest('a[href$="/cart"], a[href*="/cart?"], [data-open-cart-drawer]');
      // the drawer's own View Cart link has to be allowed to navigate, or it
      // just reopens the drawer the customer is already looking at
      if (cartLink && cartLink.closest('[data-cart-drawer]')) return;
      if (cartLink && drawer()) {
        event.preventDefault();
        refresh().then(open);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });

    // Adding something opens the drawer instead of jumping to the cart page.
    // This listens in the capture phase and stops the event there: the theme
    // has its own add handler bound on the bubble phase which navigates to
    // /cart, and it would otherwise win and take the customer off the page.
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
      if (!drawer()) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form),
        headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function () { return refresh(); })
        .then(open)
        .then(updateCount)
        .catch(function () {
          // if the ajax add fails the normal submit still has to work
          form.submit();
        });
    }, true);

    // Some add buttons are wired to a click handler rather than a real submit,
    // so the click is caught in capture too and turned into the same request.
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[name="add"], [data-add-to-cart], .product-form--atc-button');
      if (!button || !drawer()) return;

      var form = button.closest('form[action*="/cart/add"]');
      if (!form) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      fetch('/cart/add.js', { method: 'POST', body: new FormData(form),
        headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function () { return refresh(); })
        .then(open)
        .then(updateCount)
        .catch(function () { form.submit(); });
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:request', async (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      return; 
    }

    // Cancel default cart addition processing
    event.preventDefault();

    try {
      // Convert FormData to array format (expected by AddToCartFlyout)
      const formData = event.detail.form;
      const formDataArray = [];
      for (let [key, value] of formData.entries()) {
        formDataArray.push({ name: key, value: value });
      }

      const submitButton = document.querySelector('button[type="submit"], input[type="submit"]');
      
        const addToCartFlyout = new window.AddToCartFlyout(formDataArray, {
          atcButton: submitButton,
          settings: {
            moneyFormat: window.SHOP_MONEY_FORMAT
          }
        });

        // Wait for AddToCartFlyout completion and return actual response data
        const handleComplete = (completeEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.resolve(completeEvent.detail.responseData);
        };

        const handleError = (errorEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.reject(errorEvent.detail.error);
        };

        document.addEventListener('addToCartFlyout:complete', handleComplete);
        document.addEventListener('addToCartFlyout:error', handleError);

    } catch (error) {
      console.error('AddToCartFlyout error:', error);
      event.detail.reject(error);
    }
  });

  document.addEventListener('product-form:cart:navigate', (event) => {
    if (!window.CART_REDIRECTION_ENABLED) {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      window.location.href = window.Theme.routes.cart_url;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["replacement-part-finder"] && !Shopify.designMode) return;
  try {
    
  // Step two is tied to step one: it asks the storefront for products from the
  // chosen vendor, so the models and parts offered are always that brand's.
  document.querySelectorAll('[data-part-finder]').forEach(function (root) {
    var form = root.querySelector('[data-part-finder-form]');
    if (!form) return;

    var brand = form.querySelector('[data-part-finder-brand]');
    var trigger = form.querySelector('[data-part-finder-brand-trigger]');
    var brandLabel = form.querySelector('[data-part-finder-brand-label]');
    var brandList = form.querySelector('[data-part-finder-brand-list]');

    var modelTrigger = form.querySelector('[data-part-finder-model-trigger]');
    var modelSummary = form.querySelector('[data-part-finder-model-summary]');
    var panel = form.querySelector('[data-part-finder-model-panel]');
    var search = form.querySelector('[data-part-finder-model]');
    var listHead = form.querySelector('[data-part-finder-listhead]');
    var results = form.querySelector('[data-part-finder-results]');
    var status = form.querySelector('[data-part-finder-status]');
    var chips = form.querySelector('[data-part-finder-chips]');
    var hidden = form.querySelector('[data-part-finder-q]');
    var submit = form.querySelector('[data-part-finder-submit]');

    var limit = parseInt(root.getAttribute('data-suggest-limit'), 10) || 6;
    var placeholder = modelSummary.textContent.trim();
    var timer = null;
    var chosen = [];

    function closeBrandList() {
      brandList.hidden = true;
      brandList.innerHTML = '';
      trigger.setAttribute('aria-expanded', 'false');
    }

    function closePanel() {
      panel.hidden = true;
      modelTrigger.setAttribute('aria-expanded', 'false');
    }

    function openPanel() {
      closeBrandList();
      panel.hidden = false;
      modelTrigger.setAttribute('aria-expanded', 'true');
      search.focus();
    }

    function alreadyChosen(url) {
      return chosen.some(function (item) { return item.url === url; });
    }

    function markAdded() {
      Array.prototype.forEach.call(results.querySelectorAll('[data-url]'), function (button) {
        button.setAttribute('aria-selected',
          alreadyChosen(button.getAttribute('data-url')) ? 'true' : 'false');
      });
    }

    function refresh() {
      // the sku is what identifies a unit, so it is what gets shown and what
      // is sent on. The title is kept only to label the remove button.
      var allSkus = [];
      chosen.forEach(function (item) {
        allSkus = allSkus.concat(skuCache[item.handle] || []);
      });

      hidden.value = allSkus.join(' ');
      submit.disabled = !brand.value || chosen.length === 0;

      if (!chosen.length) {
        modelSummary.textContent = placeholder;
      } else if (chosen.length === 1) {
        modelSummary.textContent = skuText(chosen[0].handle).replace('SKU: ', '') || chosen[0].title;
      } else {
        modelSummary.textContent = chosen.length + ' Models Selected';
      }

      chips.innerHTML = '';
      chosen.forEach(function (item, index) {
        var li = document.createElement('li');
        li.className = 'part-finder__chip';

        var label = document.createElement('span');
        var skus = skuCache[item.handle] || [];
        label.textContent = skus.length ? skus.join(' / ') : item.title;
        li.appendChild(label);

        var remove = document.createElement('button');
        remove.type = 'button';
        remove.innerHTML = '&times;';
        remove.setAttribute('aria-label', 'Remove ' + item.title);
        remove.addEventListener('click', function () {
          chosen.splice(index, 1);
          refresh();
          markAdded();
        });
        li.appendChild(remove);

        chips.appendChild(li);
      });
    }

    var skuCache = {};

    function skuText(handle) {
      var skus = skuCache[handle] || [];
      return skus.length ? 'SKU: ' + skus.join(' / ') : '';
    }

    function loadSku(handle) {
      if (!handle) return Promise.resolve([]);

      if (Object.prototype.hasOwnProperty.call(skuCache, handle)) {
        return Promise.resolve(skuCache[handle]);
      }

      return fetch('/products/' + encodeURIComponent(handle) + '.js',
        { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(function (data) {
          // one sku for a normal product, several for a bundle
          var skus = (data.variants || []).map(function (variant) {
            return variant.sku;
          }).filter(Boolean);
          skuCache[handle] = skus;
          return skus;
        })
        .catch(function () {
          // no sku is better than a broken row
          skuCache[handle] = [];
          return [];
        });
    }

    function fillSku(handle, target) {
      loadSku(handle).then(function () { target.textContent = skuText(handle); });
    }

    function render(products) {
      results.innerHTML = '';

      if (!products.length) {
        listHead.hidden = true;
        status.textContent = search.value.trim().length < 2
          ? ''
          : 'Nothing Found For ' + brand.value + '. Try A Different Model Number.';
        return;
      }

      status.textContent = '';
      listHead.hidden = false;

      products.forEach(function (product) {
        var li = document.createElement('li');
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'part-finder__result';
        button.setAttribute('role', 'option');
        button.setAttribute('data-url', product.url);

        if (product.image) {
          var img = document.createElement('img');
          img.src = product.image;
          img.alt = '';
          img.loading = 'lazy';
          button.appendChild(img);
        }

        var span = document.createElement('span');
        var title = document.createElement('span');
        title.className = 'part-finder__result-title';
        title.textContent = product.title;
        span.appendChild(title);

        // The suggest endpoint carries a variants array but it is always
        // empty, so the sku has to come from the product itself. One small
        // request per result, cached by handle, filled in after the list is
        // already on screen so nothing waits on it.
        var sku = document.createElement('span');
        sku.className = 'part-finder__result-sku';
        span.appendChild(sku);
        fillSku(product.handle, sku);

        // The product id is stored on the product as a plain numeric tag,
        // which is why searching one finds the product at all. Reading it
        // back from the tags shows it without a second request.
        var ident = (product.tags || []).find(function (tag) {
          return /^[0-9]{4,}$/.test(String(tag).trim());
        });

        if (ident) {
          var idLine = document.createElement('span');
          idLine.className = 'part-finder__result-id';
          idLine.textContent = 'Product ID: ' + ident;
          span.appendChild(idLine);
        }

        button.appendChild(span);

        button.addEventListener('click', function () {
          if (alreadyChosen(product.url)) {
            chosen = chosen.filter(function (item) { return item.url !== product.url; });
          } else {
            chosen.push({ title: product.title, url: product.url, handle: product.handle });
            // the sku may not have arrived yet; redraw once it has
            loadSku(product.handle).then(refresh);
          }
          refresh();
          markAdded();
          // the panel shuts on a pick. Another model is added by opening it
          // again, which keeps the choice visible instead of burying it
          // under a list that stays in the way.
          closePanel();
        });

        li.appendChild(button);
        results.appendChild(li);
      });

      markAdded();
    }

    function lookup() {
      var typed = search.value.trim();

      if (!brand.value || typed.length < 2) {
        results.innerHTML = '';
        listHead.hidden = true;
        status.textContent = '';
        return;
      }

      // Two things had to be worked out by testing rather than assumed.
      //
      // The predictive endpoint has no filter syntax: a query of
      // "vendor:ACiQ GLXS" comes back with ACiQ products that have nothing to
      // do with GLXS, because the whole string is read as text and the brand
      // name merely happens to sit in the titles. So the vendor field on each
      // result is what decides, which is a real tie to step one.
      //
      // And the brand must stay out of the query. Asking for "Goodman CHPTA"
      // returns Goodman products that are not CHPTA at all, because the brand
      // words swamp the model fragment. Asking for "CHPTA" alone returns what
      // was wanted. The brand is only added back if filtering by vendor leaves
      // nothing, which rescues a fragment too short to stand on its own.
      var wanted = brand.value.toLowerCase();

      function ask(query) {
        return fetch('/search/suggest.json?q=' + encodeURIComponent(query) +
          '&resources[type]=product&resources[limit]=20',
          { headers: { Accept: 'application/json' } })
          .then(function (response) { return response.json(); })
          .then(function (data) {
            var products = ((data.resources || {}).results || {}).products || [];
            return products.filter(function (product) {
              return (product.vendor || '').toLowerCase() === wanted;
            });
          });
      }

      // A bundle is a product whose sku is several skus joined together. The
      // Bundle tag is not dependable for this: ACIQ-36ZPL-HP230C /
      // ACIQ-36FM-HH-MD is plainly two units and carries no such tag. So the
      // sku decides, which means loading the skus before anything is drawn
      // rather than filling them in afterwards. One small request per
      // candidate, cached, and they run together.
      function withoutBundles(products) {
        var candidates = products.slice(0, limit * 2);
        var asked = typed.toLowerCase().replace(/\s+/g, '');

        return Promise.all(candidates.map(function (product) {
          return loadSku(product.handle);
        })).then(function (skuLists) {
          return candidates.filter(function (product, index) {
            var skus = skuLists[index] || [];

            // A bundle is reachable by its product id and by nothing else.
            // Searching a sku, whether one component or the whole joined
            // string, is treated as browsing and keeps bundles out; the id
            // is the one key that names a bundle deliberately.
            var namedById = (product.tags || []).some(function (tag) {
              return String(tag).trim().toLowerCase() === asked;
            });

            if (namedById) return true;

            if (skus.length > 1) return false;
            return skus.every(function (sku) { return sku.indexOf('/') === -1; });
          });
        });
      }

      ask(typed)
        .then(function (mine) {
          if (mine.length) return mine;
          return ask(brand.value + ' ' + typed);
        })
        .then(withoutBundles)
        .then(function (mine) { render(mine.slice(0, limit)); })
        .catch(function () {
          // a failed lookup must not block the customer: the form still submits
          results.innerHTML = '';
          listHead.hidden = true;
          status.textContent = '';
        });
    }

    function openBrandList() {
      closePanel();
      brandList.innerHTML = '';

      Array.prototype.forEach.call(brand.options, function (option, index) {
        if (index === 0) return;
        var li = document.createElement('li');
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'part-finder__result';
        button.setAttribute('role', 'option');
        button.textContent = option.textContent.trim();
        button.addEventListener('click', function () {
          brand.selectedIndex = index;
          brand.dispatchEvent(new Event('change'));
          closeBrandList();
          trigger.focus();
        });
        li.appendChild(button);
        brandList.appendChild(li);
      });

      brandList.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
    }

    // a tooltip that only answers to hover is unreachable on a phone
    form.querySelectorAll('[data-part-finder-help]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.stopPropagation();
        var open = button.getAttribute('aria-expanded') === 'true';
        form.querySelectorAll('[data-part-finder-help]').forEach(function (other) {
          other.setAttribute('aria-expanded', 'false');
        });
        button.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });

    trigger.addEventListener('click', function () {
      if (brandList.hidden) openBrandList(); else closeBrandList();
    });

    modelTrigger.addEventListener('click', function () {
      if (panel.hidden) openPanel(); else closePanel();
    });

    brand.addEventListener('change', function () {
      brandLabel.textContent = brand.value || brand.options[0].textContent.trim();
      modelTrigger.disabled = !brand.value;

      // a model belongs to the brand it was found under, so switching brand
      // clears what was chosen rather than leaving a mismatched list behind
      chosen = [];
      search.value = '';
      results.innerHTML = '';
      listHead.hidden = true;
      status.textContent = '';
      refresh();
      if (brand.value) openPanel();
    });

    search.addEventListener('input', function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(lookup, 250);
    });

    search.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') { closePanel(); modelTrigger.focus(); }
      if (event.key === 'Enter') event.preventDefault();
    });

    document.addEventListener('click', function (event) {
      // Choosing a brand empties the brand list, which detaches the very
      // element that was clicked. By the time this runs, form.contains() is
      // false for a node that is no longer in the document at all, and the
      // panel that had just been opened was being shut again immediately.
      if (!event.target.isConnected) return;
      if (!form.contains(event.target)) { closeBrandList(); closePanel(); }
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!brand.value || !chosen.length) return;

      // One model goes straight to its listing.
      if (chosen.length === 1) {
        window.location.href = chosen[0].url;
        return;
      }

      // Several go to the search carrying every sku. The store already sends
      // an exact sku set straight to its listing, bundles included and in any
      // order, so if one product covers all of them the customer lands on it
      // and otherwise they get the results page. Nothing here has to guess
      // which of the two it will be.
      var allSkus = [];
      chosen.forEach(function (item) {
        allSkus = allSkus.concat(skuCache[item.handle] || []);
      });

      var terms = allSkus.length
        ? allSkus.join(' ')
        : chosen.map(function (item) { return item.title; }).join(' ');

      window.location.href = '/search?type=product&q=' + encodeURIComponent(terms);
    });

    modelTrigger.disabled = !brand.value;
    brandLabel.textContent = brand.value || brand.options[0].textContent.trim();
    refresh();
  });

  } catch(e) { console.error(e); }
})();
})();
